export default "__VITE_ASSET__Bl5hh7mf__"